// Inline SVG pattern backgrounds for "wild" invoice themes.
// Returns a CSS background-image data URL for the given pattern key + accent color.
export function patternBg(pattern, accent = "#000000", paperBg) {
  if (!pattern) return null;
  const svg = SVGS[pattern]?.(accent) || "";
  const enc = encodeURIComponent(svg).replace(/'/g, "%27").replace(/"/g, "%22");
  return {
    backgroundImage: `url("data:image/svg+xml,${enc}")`,
    backgroundColor: paperBg || "#FFFFFF",
    backgroundRepeat: "repeat",
  };
}

const SVGS = {
  "art-deco": (c) => `
    <svg xmlns='http://www.w3.org/2000/svg' width='120' height='120'>
      <g fill='none' stroke='${c}' stroke-width='0.6' opacity='0.15'>
        <path d='M60 0 L0 60 L60 120 L120 60 Z'/>
        <path d='M60 20 L20 60 L60 100 L100 60 Z'/>
        <path d='M60 40 L40 60 L60 80 L80 60 Z'/>
        <circle cx='60' cy='60' r='2' fill='${c}'/>
      </g>
    </svg>`,
  "blueprint": (c) => `
    <svg xmlns='http://www.w3.org/2000/svg' width='40' height='40'>
      <g stroke='${c}' stroke-width='0.4' opacity='0.25' fill='none'>
        <path d='M0 0 H40 M0 40 H40 M0 0 V40 M40 0 V40'/>
        <path d='M0 20 H40 M20 0 V40'/>
      </g>
    </svg>`,
  "marble": (c) => `
    <svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'>
      <filter id='t'><feTurbulence type='fractalNoise' baseFrequency='0.012' numOctaves='3' seed='5'/><feColorMatrix values='0 0 0 0 ${hexN(c,0)} 0 0 0 0 ${hexN(c,1)} 0 0 0 0 ${hexN(c,2)} 0 0 0 0.12 0'/></filter>
      <rect width='200' height='200' filter='url(#t)'/>
    </svg>`,
  "parchment": (c) => `
    <svg xmlns='http://www.w3.org/2000/svg' width='160' height='160'>
      <filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' seed='3'/><feColorMatrix values='0 0 0 0 ${hexN(c,0)} 0 0 0 0 ${hexN(c,1)} 0 0 0 0 ${hexN(c,2)} 0 0 0 0.08 0'/></filter>
      <rect width='160' height='160' filter='url(#n)'/>
    </svg>`,
  "geo": (c) => `
    <svg xmlns='http://www.w3.org/2000/svg' width='80' height='80'>
      <g fill='${c}' opacity='0.06'>
        <polygon points='0,0 40,0 20,40'/>
        <polygon points='40,0 80,0 60,40'/>
        <polygon points='20,40 60,40 40,80'/>
      </g>
    </svg>`,
};

function hexN(hex, idx) {
  const h = hex.replace("#", "");
  const v = parseInt(h.slice(idx * 2, idx * 2 + 2), 16) / 255;
  return v.toFixed(2);
}
